import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-common/dist/components/error-boundary/GlobalErrorHandler.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-common/dist/components/image/CustomImage.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationScrollPaddingFix"] */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-common/dist/components/navigation/NavigationScrollPaddingFix.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/ClientPageProviders.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/cosmos-agreement/CosmosPageAgreement.client.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/cosmos-auth/CosmosPageAuth.client.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/cosmos-blog-detail/CosmosPageBlogDetail.client.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/cosmos-error-test/ErrorTestPage.client.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/cosmos-eula-key/CosmosPageEulaKey.client.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/cosmos-legal-content/CosmosPageLegalContent.client.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/cosmos-license/CosmosPageLicense.client.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/cosmos-plugin-detail/CosmosPagePluginDetail.client.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["CosmosPageResearch"] */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/cosmos-research/CosmosPageResearch.client.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/cosmos-search/CosmosSearch.client.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/libraries/next-templates/dist/templates/TemplateProviders.jsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/node_modules/.pnpm/next@15.5.9_@babel+core@7.28.5_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react_685b2b2b6fa72b76f442e97a1deee407/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/runner/_work/cosmos-src/cosmos-src/websites/legalhub-website/src/app/context/component-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LegalHubHomeClient"] */ "/runner/_work/cosmos-src/cosmos-src/websites/legalhub-website/src/app/templates/document-list/DocumentListPage.client.tsx");
